<div class="content text-center animated fadeIn fast">
  <div class="image" [ngClass]="{'unexpected': data.type === 'unexpected', 'no-results': data.type === 'no-results'}">
    <div class="img-position">
      <img *ngIf="data.type === 'unexpected'" src="assets/images/no-results/unexpected.png" alt="No hay resultados"/>
      <img *ngIf="data.type === 'no-results'" src="assets/images/no-results/no-results.png" alt="No hay resultados"/>
    </div>
  </div>
  <h4 class="secondary">
    {{ data.message }}
  </h4>
  
</div>
